import type { ReactElement } from 'react';

import { Icon } from '../icons';

import type { TLogoProps } from './logo.interface';

export const Logo = ({ size = 'small' }: TLogoProps): ReactElement => {
  function createSize(): { width: number; height: number } {
    if (size === 'large') {
      return { width: 80, height: 80 };
    }
    if (size === 'medium') {
      return { width: 60, height: 60 };
    }
    return { width: 40, height: 40 };
  }
  return <Icon icon="LogoParisFilledIcon" {...createSize()} />;
};
